export default __webpack_public_path__ + "static/media/github.44adc623.svg";